<script>
import axios from '@/utils/axios';
import { countries, states, pincodeWiseAddress } from '@/utils/admin';
import { getBrands } from '@/utils/brands'

export default {
 inject: ['setLoading'],  
  data() {
    return {
    brands: [],
    brand_ids: [],
     errors: {}, 
     id: '',
     code: '',
     name: '',
     email: '',
     mobile: '',
     gst_no: '',
     contact_id: '',
     contact_name: '',
     contact_email: '',
     contact_mobile: '',
     company_name: '',
     contact_designation: '',
     address: '',
     city: '',
     state: null,
     pincode: '',
     country: null,
     states: [],
     countries: [],
     bank_name: '',
     account_no: '',
     account_holder_name: '',
     ifsc: '',
     bank_branch: '',
     contacts: [],
     module_url: 'inventory/vendors'
    };
  },
  
  methods: {

    async allBrands(){
  try{
    const res = await getBrands();
    this.brands = res?.data?.data?.data || [];
  }catch(error){
    this.$swalToast(error.message,'error');
  }
},
   
  async vendor(row = null){
   this.resetForm();
   await this.getCountries();
   await this.allBrands();
    if(row !== null){
     this.id = row.id; 
     this.code = row.code;
     this.name = row.name;
     this.city = row.city;
     this.email = row.email;
     this.gst_no = row.gst_no;
     this.mobile = row.mobile;
     this.address = row.address;
     this.pincode = row.pincode;
     this.bank_name = row.bank_name;
     this.account_no = row.account_no;
     this.ifsc = row.ifsc;
     this.bank_branch = row.bank_branch;
     this.company_name = row.company_name;
     this.contacts = row?.contacts;
     this.account_holder_name = row.account_holder_name;
      this.brand_ids = (row.brands || []).map(b => b.id);
     this.country = this.countries.find(country => country.name === row.country);
    //LOAD STATES
    await this.getStates(this.country?.id);
    this.state = this.states.find(state => state.name === row.state);
   }
  },

   async saveVendor(){
    this.errors = {};
    this.setLoading(true); 

    try{
     const payload = {
      // code: this.code,
      name: this.name,  
      city: this.city,
      email: this.email,
      mobile: this.mobile,
      gst_no: this.gst_no,     
      address: this.address,
      pincode: this.pincode,
      state: this.state?.name,
      country: this.country?.name,
      company_name: this.company_name,
      bank_name: this.bank_name,
      account_no: this.account_no,
      ifsc: this.ifsc,
      bank_branch: this.bank_branch,
      account_holder_name: this.account_holder_name,
      brand_ids: this.brand_ids,
     }; 
     let response = [];
     if(this.id){
      //UPDATE
      response = await axios.put(`/${this.module_url}/${this.id}`, payload);
     }else{
      //CREATE
      response = await axios.post(`/${this.module_url}`, payload);
     }
     this.$swalToast(response.data.message);
     this.$emit('updated'); 
     this.$closeModal('vendor_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){  
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteVendor(){
   this.errors = {};
   this.setLoading(true); 
   try{
    const response = await axios.delete(`/${this.module_url}/${this.id}`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.$closeModal('vendor_delete_modal');
   }catch(error){
    if(error.type == 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error'); 
    }
   }finally{
    this.setLoading(false);
   }
  },

  async getCountries(){
   this.setLoading(true);
   try{
    const response = await countries();
    this.countries = response.data.data;
    if(!this.id){
     //if creating new customer, then set default country 
     this.country = this.countries.find(c => c.name === this.clientAdmin?.company?.country);
    }
    this.getStates(this.country?.id);
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   } 
  },

  onCountrySelect(country){
   this.getStates(country?.id);
  },

  async getStates(country_id){
   this.state = null;
   this.states = [];
    if(country_id){
    try{ 
     const response = await states(country_id);
     this.states = response.data.data;
     //if creating new customer, then set default country 
     this.state = this.states.find(s => s.name === this.clientAdmin?.company?.state);
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   }  
  },

  checkPincode(){
   if(this.pincode.length < 6){
    this.errors.pincode = ["The pincode field must be 6 digits."];
   }else{
    delete this.errors.pincode;
    clearTimeout(this.pincodeTimeout);
    this.pincodeTimeout = setTimeout(() => {
     this.addressByPincode();
    }, 500);   
   }
  },

  async addressByPincode(){
   this.setLoading(true);
   try{
    const response = await pincodeWiseAddress(this.pincode);
    const data = response.data.data;
    const new_country = data?.country ? this.countries.find(c => c.name === data.country) : this.country;
    this.city = data?.city || this.city;
    if(new_country && new_country?.id !== this.country?.id){
     this.country = new_country;
     await this.getStates(new_country.id);
     this.state = data?.state ? this.states.find(s => s.name === data.state) : this.state;
    }else if(data?.state){
     this.state = this.states.find(s => s.name === data.state);
    }
   }catch(error){
    console.log('Pincode lookup failed:', error.message);
   }finally{
    this.setLoading(false);
   }
  },

  vendorContact(vendor_id, vendor_code, contact = null){
   this.id = vendor_id;
   this.code = vendor_code;
   
   if(contact !== null){
    this.contact_id = contact.id;
    this.contact_name = contact.name;
    this.contact_email = contact.email;
    this.contact_mobile = contact.mobile;
    this.contact_designation = contact.designation;
   }
  },

  async saveVendorContact(){
   this.errors = {};
   this.setLoading(true);
   try{
    const payload = {
     name: this.contact_name,
     email: this.contact_email,
     mobile: this.contact_mobile,
     designation: this.contact_designation,
    };
    
    let response = [];
    if(this.contact_id){
     response = await axios.put(`/${this.module_url}/${this.id}/contacts/${this.contact_id}`, payload);
    }else{
     response = await axios.post(`/${this.module_url}/${this.id}/contacts`, payload); 
    }

    this.$emit('updated');
    this.$swalToast(response.data.message);
    this.$closeModal('vendor_contact_modal');

   }catch(error){
    if(error.type === 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error'); 
    }
   }finally{
    this.setLoading(false);
   }
  },

  async deleteVendorContact(){
   this.setLoading(true);
   try{
    const response = await axios.delete(`/${this.module_url}/${this.contact_id}/contact`);
    this.$emit('updated');
    this.$closeModal('vendor_contact_delete_modal');
    this.$swalToast(response.data.message);
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   } 
  },

  resetForm() {
   this.id = null;
   this.code = '';
   this.name = '';
   this.email = '';
   this.gst_no = '';
   this.mobile = '';
   this.address = '';
   this.city = '';
   this.state = '';
   this.pincode = '';
   this.country = '';
   this.contact_designation = '';
   this.errors = {};
   this.company_name = '';
   this.bank_name = '';
   this.account_no = '';
   this.account_holder_name = '';
   this.ifsc = '';
   this.bank_branch = '';
   this.contact_id = '';
   this.contact_name = '';
   this.contact_email = '';
   this.contact_mobile = '';
  },

  },
};
</script>

<template>

  <!-- ===== VENDOR ADD/EDIT MODAL ===== -->
  <div class="modal fade" id="vendor_modal">
    <div class="modal-dialog modal-dialog-centered modal-mg w-100">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

        <div class="modal-header" style="background:#f8f9fb;border-bottom:1px solid #f0f1f5;padding:16px 20px;">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;background:#fff0f0;border-radius:8px;">
              <i class="ti ti-user-dollar" style="font-size:17px;color:#e84040;"></i>
            </span>
            <h4 class="modal-title" style="font-size:15px;font-weight:600;margin:0;color:#1a1d23;">
              {{ id ? 'Edit' : 'Add' }} Vendor
            </h4>
          </div>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="saveVendor">
          <div class="modal-body" style="padding:16px;background:#fff;max-height:75vh;overflow-y:auto;">

            <!-- Section: Basic Info -->
            <div style="font-size:11px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:12px;">
              Basic Information
            </div>

            <div class="row g-3 mb-1">
              <div class="col-md-7">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="name" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.name" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.name[0] }}</div>
              </div>
              <div class="col-md-5">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Mobile No <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="mobile" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.mobile" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.mobile[0] }}</div>
              </div>

              <!-- <div class="col-md-5">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Code <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="code" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.code" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.code[0] }}</div>
              </div> -->
            </div>

            <div class="row g-3 mt-1 mb-1">

              <div class="col-md-6">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Email ID <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="email" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.email" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.email[0] }}</div>
              </div>
              <div class="col-md-6">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Company Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="company_name" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.company_name" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.company_name[0] }}</div>
              </div>
            </div>

            <div class="row g-3 mt-1">
              <div class="col-md-5">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">GST No <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="gst_no" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.gst_no" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.gst_no[0] }}</div>
              </div>
              <div class="col-md-7">
                  <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Brands</label>
                  <vue-select :options="brands" label="name" v-model="brand_ids" :reduce="b => b.id" placeholder="Select Brands" multiple />
                  <div v-if="errors.brand_ids" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.brand_ids[0] }}</div>
              </div>
            </div>

            <!-- Divider -->
            <div style="border-top:1px dashed #f0f1f5;margin:16px 0;"></div>

            <!-- Section: Address -->
            <div style="font-size:11px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:12px;">
              Address Details
            </div>

            <div class="row g-3 mb-1">
              <div class="col-md-7">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Street Address <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="address" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.address" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.address[0] }}</div>
              </div>
              <div class="col-md-5">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Pincode <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="pincode" maxlength="6" @keyup="checkPincode" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.pincode" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.pincode[0] }}</div>
              </div>
            </div>

            <div class="row g-3 mt-1">
              <div class="col-md-3">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">City <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="city" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.city" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.city[0] }}</div>
              </div>
              <div class="col-md-4">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Country <span class="text-danger">*</span></label>
                <vue-select :options="countries" label="name" v-model="country" @update:modelValue="onCountrySelect" />
                <div v-if="errors.country" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.country[0] }}</div>
              </div>
              <div class="col-md-5">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">State <span class="text-danger">*</span></label>
                <vue-select :options="states" label="name" v-model="state" />
                <div v-if="errors.state" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.state[0] }}</div>
              </div>
            </div>

            <!-- Divider -->
            <div style="border-top:1px dashed #f0f1f5;margin:16px 0;"></div>

            <!-- Section: Bank Details -->
            <div style="font-size:11px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:12px;">
              Bank Details
            </div>

            <div class="row g-3 mb-1">
              <div class="col-md-6">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Bank Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="bank_name" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.bank_name" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.bank_name[0] }}</div>
              </div>
              <div class="col-md-6">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Account No <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="account_no" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.account_no" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.account_no[0] }}</div>
              </div>
            </div>

            <div class="row g-3 mt-1">
              <div class="col-md-6">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Account Holder Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="account_holder_name" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.account_holder_name" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.account_holder_name[0] }}</div>
              </div>
              <div class="col-md-3">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">IFSC Code <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="ifsc" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.ifsc" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.ifsc[0] }}</div>
              </div>
              <div class="col-md-3">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Bank Branch <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="bank_branch" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.bank_branch" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.bank_branch[0] }}</div>
              </div>
            </div>

          </div>

          <div class="modal-footer" style="background:#f8f9fb;border-top:1px solid #f0f1f5;padding:14px 20px;gap:8px;">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal"
              style="font-size:13px;border-radius:8px;padding:8px 18px;border:1.5px solid #e8eaf0;">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary"
              style="font-size:13px;border-radius:8px;padding:8px 22px;background:#e84040;border:none;font-weight:500;">
              {{ id ? 'Update' : 'Save' }} Vendor
            </button>
          </div>
        </form>

      </div>
    </div>
  </div>
  <!-- /Vendor -->


  <!-- ===== DELETE MODAL ===== -->
  <div class="modal fade" id="vendor_delete_modal">
    <div class="modal-dialog modal-dialog-centered" style="max-width:380px;">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">
        <div class="modal-body text-center" style="padding:32px 24px;">
          <div style="display:inline-flex;align-items:center;justify-content:center;width:60px;height:60px;background:#fff0f0;border-radius:50%;margin-bottom:16px;">
            <i class="ti ti-trash-x" style="font-size:28px;color:#e84040;"></i>
          </div>
          <h5 style="font-size:16px;font-weight:600;color:#1a1d23;margin-bottom:8px;">Delete Vendor?</h5>
          <p style="font-size:13px;color:#8a8f9e;margin-bottom:24px;line-height:1.6;">
            This action cannot be undone. The vendor and all its data will be permanently removed.
          </p>
          <div style="display:flex;gap:10px;justify-content:center;">
            <a href="javascript:void(0);" class="btn btn-light" data-bs-dismiss="modal"
              style="font-size:13px;border-radius:8px;padding:9px 22px;border:1.5px solid #e8eaf0;color:#5a6272;">
              Cancel
            </a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteVendor"
              style="font-size:13px;border-radius:8px;padding:9px 22px;background:#e84040;border:none;font-weight:500;">
              Yes, Delete
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->


  <!-- ===== CONTACT ADD/EDIT MODAL ===== -->
  <div class="modal fade" id="vendor_contact_modal">
    <div class="modal-dialog modal-dialog-centered modal-mg w-100">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

        <div class="modal-header" style="background:#f8f9fb;border-bottom:1px solid #f0f1f5;padding:16px 20px;">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;background:#f0f7ff;border-radius:8px;">
              <i class="ti ti-address-book" style="font-size:17px;color:#2563eb;"></i>
            </span>
            <h4 class="modal-title" style="font-size:15px;font-weight:600;margin:0;color:#1a1d23;">
              {{ code }}'s Contact
            </h4>
          </div>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="saveVendorContact">
          <div class="modal-body" style="padding:20px;background:#fff;">
            <div class="row g-3">
              <div class="col-md-6">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="contact_name" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.name" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.name[0] }}</div>
              </div>
              <div class="col-md-6">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Mobile No <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="contact_mobile" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.mobile" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.mobile[0] }}</div>
              </div>
              <div class="col-md-6">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Email ID</label>
                <input type="text" class="form-control" v-model="contact_email" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.email" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.email[0] }}</div>
              </div>
              <div class="col-md-6">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">Designation</label>
                <input type="text" class="form-control" v-model="contact_designation" style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.designation" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;"><i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.designation[0] }}</div>
              </div>
            </div>
          </div>

          <div class="modal-footer" style="background:#f8f9fb;border-top:1px solid #f0f1f5;padding:14px 20px;gap:8px;">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal"
              style="font-size:13px;border-radius:8px;padding:8px 18px;border:1.5px solid #e8eaf0;">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary"
              style="font-size:13px;border-radius:8px;padding:8px 22px;background:#e84040;border:none;font-weight:500;">
              Save Contact
            </button>
          </div>
        </form>

      </div>
    </div>
  </div>
  <!-- /Contacts -->


  <!-- ===== VIEW DETAIL MODAL ===== -->
  <div class="modal fade" id="vendor_detail_modal">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

        <div class="modal-header" style="background:#f8f9fb;border-bottom:1px solid #f0f1f5;padding:16px 20px;">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;background:#fff0f0;border-radius:8px;">
              <i class="ti ti-user-dollar" style="font-size:17px;color:#e84040;"></i>
            </span>
            <h4 class="modal-title" style="font-size:15px;font-weight:600;margin:0;color:#1a1d23;">{{ code }}</h4>
          </div>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>

        <div class="modal-body" style="padding:20px;max-height:75vh;overflow-y:auto;">

          <!-- Two column detail layout -->
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:0;">

            <div style="display:flex;padding:10px 12px 10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
              <span style="min-width:100px;font-size:12px;font-weight:500;color:#9e9e9e;">Name</span>
              <span style="font-size:13px;color:#1a1d23;font-weight:500;">{{ name }}</span>
            </div>

            <div v-if="company_name" style="display:flex;padding:10px 0 10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
              <span style="min-width:100px;font-size:12px;font-weight:500;color:#9e9e9e;">Company</span>
              <span style="font-size:13px;color:#1a1d23;">{{ company_name }}</span>
            </div>

            <div style="display:flex;padding:10px 12px 10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
              <span style="min-width:100px;font-size:12px;font-weight:500;color:#9e9e9e;">Email</span>
              <span style="font-size:13px;color:#1a1d23;">{{ email }}</span>
            </div>

            <div style="display:flex;padding:10px 0 10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
              <span style="min-width:100px;font-size:12px;font-weight:500;color:#9e9e9e;">Contact No</span>
              <span style="font-size:13px;color:#1a1d23;">{{ mobile }}</span>
            </div>

            <div v-if="gst_no" style="display:flex;padding:10px 12px 10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
              <span style="min-width:100px;font-size:12px;font-weight:500;color:#9e9e9e;">GSTIN</span>
              <span style="font-size:13px;color:#1a1d23;">{{ gst_no }}</span>
            </div>

            <div style="display:flex;padding:10px 0 10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
              <span style="min-width:100px;font-size:12px;font-weight:500;color:#9e9e9e;">Address</span>
              <span style="font-size:13px;color:#1a1d23;line-height:1.6;"><span v-if="address">{{ address }}, </span>{{ city }}, {{ state?.name }} - {{ pincode }}</span>
            </div>

          </div>

          <!-- Bank Details -->
          <div style="font-size:11px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin:16px 0 10px;">
            Bank Details
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:0;border:1px solid #f4f5f8;border-radius:8px;overflow:hidden;">

            <div style="display:flex;padding:10px 12px;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
              <span style="min-width:110px;font-size:12px;font-weight:500;color:#9e9e9e;">Bank Name</span>
              <span style="font-size:13px;color:#1a1d23;">{{ bank_name }}</span>
            </div>

            <div style="display:flex;padding:10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
              <span style="min-width:110px;font-size:12px;font-weight:500;color:#9e9e9e;">Account No</span>
              <span style="font-size:13px;color:#1a1d23;">{{ account_no }}</span>
            </div>

            <div style="display:flex;padding:10px 12px;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
              <span style="min-width:110px;font-size:12px;font-weight:500;color:#9e9e9e;">Holder Name</span>
              <span style="font-size:13px;color:#1a1d23;">{{ account_holder_name }}</span>
            </div>

            <div style="display:flex;padding:10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
              <span style="min-width:110px;font-size:12px;font-weight:500;color:#9e9e9e;">IFSC Code</span>
              <span style="font-size:13px;color:#1a1d23;">{{ ifsc }}</span>
            </div>

            <div style="display:flex;padding:10px 12px;align-items:flex-start;gap:10px;">
              <span style="min-width:110px;font-size:12px;font-weight:500;color:#9e9e9e;">Bank Branch</span>
              <span style="font-size:13px;color:#1a1d23;">{{ bank_branch }}</span>
            </div>

          </div>

          <!-- Contacts Table -->
          <div v-if="contacts.length" style="margin-top:20px;">
            <div style="font-size:11px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:10px;">
              Contacts
            </div>
            <div style="border:1px solid #f0f1f5;border-radius:8px;overflow:hidden;">
              <table class="table table-responsive" style="margin:0;font-size:13px;">
                <thead>
                  <tr style="background:#f8f9fb;">
                    <th style="font-size:11.5px;font-weight:600;color:#fff;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Name</th>
                    <th style="font-size:11.5px;font-weight:600;color:#fff;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Designation</th>
                    <th style="font-size:11.5px;font-weight:600;color:#fff;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Email</th>
                    <th style="font-size:11.5px;font-weight:600;color:#fff;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Mobile</th>
                    <th style="font-size:11.5px;font-weight:600;color:#fff;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in contacts" :key="index">
                    <td style="padding:10px 14px;color:#1a1d23;font-weight:500;border-bottom:1px solid #f4f5f8;">{{ row.name }}</td>
                    <td style="padding:10px 14px;color:#5a6272;border-bottom:1px solid #f4f5f8;">{{ row.designation ?? 'N/A' }}</td>
                    <td style="padding:10px 14px;color:#5a6272;border-bottom:1px solid #f4f5f8;">{{ row.email ?? 'N/A' }}</td>
                    <td style="padding:10px 14px;color:#5a6272;border-bottom:1px solid #f4f5f8;">{{ row.mobile }}</td>
                    <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;">
                      <a href="javascript:void(0);" class="me-3"
                        data-bs-toggle="modal" data-bs-target="#vendor_contact_modal"
                        @click="vendorContact(id, code, row);"
                        style="color:#2563eb;font-size:14px;">
                        <i class="ti ti-edit"></i>
                      </a>
                      <a href="javascript:void(0);"
                        data-bs-toggle="modal" data-bs-target="#vendor_contact_delete_modal"
                        @click="vendorContact(id, code, row);"
                        style="color:#e84040;font-size:14px;">
                        <i class="ti ti-trash"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- /View Detail Modal -->


  <!-- ===== DELETE CONTACT MODAL ===== -->
  <div class="modal fade" id="vendor_contact_delete_modal">
    <div class="modal-dialog modal-dialog-centered" style="max-width:380px;">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">
        <div class="modal-body text-center" style="padding:32px 24px;">
          <div style="display:inline-flex;align-items:center;justify-content:center;width:60px;height:60px;background:#fff0f0;border-radius:50%;margin-bottom:16px;">
            <i class="ti ti-trash-x" style="font-size:28px;color:#e84040;"></i>
          </div>
          <h5 style="font-size:16px;font-weight:600;color:#1a1d23;margin-bottom:8px;">Delete Contact?</h5>
          <p style="font-size:13px;color:#8a8f9e;margin-bottom:24px;line-height:1.6;">
            This action cannot be undone. The contact will be permanently removed.
          </p>
          <div style="display:flex;gap:10px;justify-content:center;">
            <a href="javascript:void(0);" class="btn btn-light" data-bs-dismiss="modal"
              style="font-size:13px;border-radius:8px;padding:9px 22px;border:1.5px solid #e8eaf0;color:#5a6272;">
              Cancel
            </a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteVendorContact"
              style="font-size:13px;border-radius:8px;padding:9px 22px;background:#e84040;border:none;font-weight:500;">
              Yes, Delete
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Contact Modal -->

</template>
